import React from "react";
import { Tooltip } from "antd";
import { calibrate } from "./WaterChart";

// 機具列表上的數值狀態列。
//
// 三個量值各自可能是 null（沒測到、水位來源設 none、流量超出率定範圍），
// 一律顯示「—」而不是 0 或 NaN —— 舊版顯示 NaN 是因為 a/b 缺值時
// `useState([state.a, ...] || [1,1,1])` 的預設值永遠不會生效（陣列恆為
// truthy）。
//
// 低可信度要明顯標示。LSPIV 在靜水時相關係數會接近 1、有效向量接近 100%，
// 算出接近 0 的流速 —— 數字看起來很正常，實際上量到的是沒在動的東西。沒有
// 這個標示，使用者無從分辨。

function Value({ label, value, unit }) {
  const text = value === null || value === undefined
    ? "—"
    : Number(value).toFixed(2);
  return (
    <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
      <span style={{ color: "var(--secondary-text)" }}>{label}</span>
      <span style={{ fontVariantNumeric: "tabular-nums", fontWeight: 500 }}>
        {text}
        {value !== null && value !== undefined && unit ? ` ${unit}` : ""}
      </span>
    </div>
  );
}

export default function WaterStatus({ station, latest }) {
  if (!station) return <span style={{ color: "var(--secondary-text)" }}>載入中…</span>;

  const quality = latest?.quality || null;
  const untrusted = quality && quality.trusted === false;
  const stale = latest?.time
    ? Date.now() - new Date(latest.time).getTime() > 3 * 3600 * 1000
    : false;

  return (
    <div style={{ minWidth: 200, fontSize: 13, lineHeight: 1.7 }}>
      <Value label={station.parameter1 || "水位"}
             value={calibrate(latest?.water_level, station.a, station.b)}
             unit={station.unit1 && station.unit1 !== "--" ? station.unit1 : "m"} />
      <Value label={station.parameter2 || "平均表面流速"}
             value={calibrate(latest?.average_velocity, station.ra, station.rb)}
             unit={station.unit2 && station.unit2 !== "--" ? station.unit2 : "m/s"} />
      <Value label={station.parameter3 || "推估流量"}
             value={calibrate(latest?.discharge, station.sa, station.sb)}
             unit={station.unit3 && station.unit3 !== "--" ? station.unit3 : "cms"} />

      <div style={{ marginTop: 4, fontSize: 11, color: "var(--secondary-text)" }}>
        {latest?.time ? (
          <span style={{ color: stale ? "#d4820a" : undefined }}>
            {new Date(latest.time).toLocaleString([], {
              month: "2-digit", day: "2-digit",
              hour: "2-digit", minute: "2-digit",
            })}
            {stale ? "（逾時未更新）" : ""}
          </span>
        ) : (
          "尚無量測資料"
        )}
        {!station.enabled && <span style={{ marginLeft: 6 }}>・排程未啟用</span>}
      </div>

      {untrusted && (
        <Tooltip title={(quality.warnings || []).join("；") || "品質指標低於門檻"}>
          <div style={{ marginTop: 2, fontSize: 11, color: "#d4820a",
                        cursor: "help" }}>
            ⚠ 低可信度
          </div>
        </Tooltip>
      )}
    </div>
  );
}